import { mount } from "@vue/test-utils";
import Paso2 from "@/views/Paso2";

jest.mock("@/views/Paso2", () => ({
  ...jest.requireActual("@/views/Paso2"),
  __esModule: true,
  default: {
    facturacionUltimoBalance: "mockedValue"
  }
}));

describe("Paso2 test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(Paso2);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Paso2", () => {
    expect(wrapper).toBeDefined();
  });
});
